import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const MajorClientsSection = () => {
  const majorClients = [
  {
    id: 1,
    name: "McDonald\'s South Africa",
    logo: "https://images.unsplash.com/photo-1627399581332-1437238c9861",
    logoAlt: "McDonald\'s golden arches logo on red background representing global fast food brand partnership",
    description: "Complete plumbing and electrical infrastructure for multiple restaurant locations across the region.",
    projectCount: 45,
    yearsPartnership: 12,
    services: ["Kitchen Plumbing", "Electrical Systems", "Emergency Response", "Preventive Maintenance"]
  },
  {
    id: 2,
    name: "KFC South Africa",
    logo: "https://images.unsplash.com/photo-1697616660956-6c0afd855125",
    logoAlt: "KFC Colonel Sanders logo in red and white representing international fried chicken restaurant chain partnership",
    description: "Specialized commercial kitchen installations and ongoing maintenance for high-volume operations.",
    projectCount: 38,
    yearsPartnership: 10,
    services: ["Commercial Kitchen Setup", "Grease Trap Systems", "Electrical Installations", "24/7 Support"]
  },
  {
    id: 3,
    name: "Major Retail Chains",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12a638202-1766959266777.png",
    logoAlt: "Modern retail store interior with bright lighting and organized product displays representing commercial retail partnerships",
    description: "Comprehensive electrical and plumbing solutions for shopping centers and retail outlets.",
    projectCount: 62,
    yearsPartnership: 15,
    services: ["Retail Plumbing", "Lighting Systems", "HVAC Integration", "Facility Management"]
  }];


  return (
    <section className="py-16 md:py-20 lg:py-24 bg-muted">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Building2" size={20} color="var(--color-primary)" />
            <span className="text-primary font-semibold text-sm font-accent">Major Partnerships</span>
          </div>
          <h2 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
            Trusted by Industry Leaders
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-3xl mx-auto font-body">
            Our proven track record with major brands demonstrates our capability to handle complex commercial projects with precision and reliability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {majorClients?.map((client) =>
          <div
            key={client?.id}
            className="bg-card rounded-xl shadow-card hover:shadow-elevated transition-all duration-300 overflow-hidden group">

              <div className="relative h-48 md:h-56 overflow-hidden bg-gradient-to-br from-primary/5 to-secondary/5">
                <Image
                src={client?.logo}
                alt={client?.logoAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent"></div>
              </div>

              <div className="p-6">
                <h3 className="font-headline font-bold text-xl md:text-2xl text-foreground mb-3">
                  {client?.name}
                </h3>
                <p className="text-muted-foreground mb-6 font-body leading-relaxed">
                  {client?.description}
                </p>

                <div className="grid grid-cols-2 gap-4 mb-6 pb-6 border-b border-border">
                  <div>
                    <p className="text-2xl md:text-3xl font-bold text-primary font-headline">{client?.projectCount}+</p>
                    <p className="text-sm text-muted-foreground font-body">Projects</p>
                  </div>
                  <div>
                    <p className="text-2xl md:text-3xl font-bold text-primary font-headline">{client?.yearsPartnership}</p>
                    <p className="text-sm text-muted-foreground font-body">Years Partnership</p>
                  </div>
                </div>

                <div className="space-y-2">
                  {client?.services?.map((service, index) =>
                <div key={index} className="flex items-center gap-2">
                      <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
                      <span className="text-sm text-foreground font-body">{service}</span>
                    </div>
                )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <a
            href="tel:0827935785"
            className="inline-flex items-center gap-3 bg-accent text-accent-foreground px-8 py-4 rounded-lg font-semibold text-lg hover:bg-accent/90 transition-all emergency-cta">

            <Icon name="Phone" size={24} />
            <span className="font-accent">Discuss Your Commercial Project</span>
          </a>
        </div>
      </div>
    </section>);

};

export default MajorClientsSection;